import { render, staticRenderFns } from "./center_2.vue?vue&type=template&id=80046f36&scoped=true&"
import script from "./center_2.vue?vue&type=script&lang=js&"
export * from "./center_2.vue?vue&type=script&lang=js&"
import style0 from "./center_2.vue?vue&type=style&index=0&id=80046f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80046f36",
  null
  
)

export default component.exports